<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <custom-popup
          v-model="priceDial"
          :cons="{
            title: $t('listCardHeader.group_qr_renewal'),
            icon: 'timer-refresh-outline',
          }"
          hide-confirm
          max-width="850"
          transition="dialog-bottom-transition"
          @close="() => (time = 0)"
        >
          <v-card-title class="pt-4">{{
            $t("listCardHeader.select_desired_duration")
          }}</v-card-title>
          <v-container class="pa-8 pt-4">
            <v-row v-if="!time">
              <v-col
                v-for="(item, i) in translatedRenewalItems"
                :key="i"
                cols="12"
                md="6"
                class="pa-4"
              >
                <v-card
                  :loading="priceloading"
                  elevation="2"
                  rounded="lg"
                  class="pa-3"
                  style="
                    border-top: 6px solid orange;
                    border-bottom: 6px solid orange;
                  "
                >
                  <div class="text-center mb-4">
                    <v-chip
                      :loading="priceloading"
                      color="orange"
                      text-color="white"
                      class="font-weight-bold text-h6"
                      @click="getPrice(item.value)"
                    >
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <v-icon left>mdi-clock</v-icon>
                        {{ item.text }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-${item.text}`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          :label="item.text"
                        />
                      </div>
                    </v-chip>
                  </div>
                  <v-divider class="my-4" />
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" md="6" class="pa-2">
                <v-row>
                  <v-col
                    v-for="(item, i) in translatedRenewalItems"
                    :key="i"
                    cols="12"
                    class="pa-2"
                  >
                    <v-card
                      :loading="priceloading && item.value === time"
                      elevation="2"
                      rounded="lg"
                      class="pa-2"
                      :style="{
                        borderTop:
                          item.value === time
                            ? '6px solid #BF360C'
                            : '6px solid orange',
                        borderBottom:
                          item.value === time
                            ? '6px solid #BF360C'
                            : '6px solid orange',
                      }"
                    >
                      <div class="text-center mb-1">
                        <v-chip
                          :loading="priceloading && item.value === time"
                          :color="item.value === time ? '#BF360C' : 'orange'"
                          text-color="white"
                          class="font-weight-bold text-h6"
                          @click="
                            item.value === time
                              ? (time = 0)
                              : getPrice(item.value)
                          "
                        >
                          <div
                            style="
                              display: flex;
                              justify-content: center;
                              align-items: center;
                            "
                          >
                            <v-icon left>mdi-clock</v-icon>
                            {{ item.text }}
                            {{
                              item.value === time
                                ? $t("listCardHeader.selected")
                                : ""
                            }}
                            <help-info
                              :element-name="`${serviceName}-${componentName}-${item.text}`"
                              :help-data="helpData"
                              :service-name="serviceName"
                              class="buttoninfo"
                              :label="item.text"
                            />
                          </div>
                        </v-chip>
                      </div>
                      <v-divider class="my-2" />
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="pa-2">
                <v-card
                  :loading="cardloading && time === selectedTime"
                  elevation="5"
                  rounded="lg"
                  class="pa-4"
                  style="
                    border-top: 8px solid #ca3102ff;
                    border-bottom: 8px solid #ca3102ff;
                  "
                >
                  <div class="text-center mb-4">
                    <v-chip
                      color="#ca3102ff"
                      text-color="white"
                      class="font-weight-bold text-h6"
                      @click="showCardDetails(time)"
                    >
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <v-icon left>mdi-clock</v-icon>
                        {{ $t("listCardHeader.view") }}
                        {{
                          translatedRenewalItems.find((it) => it.value === time)
                            .text
                        }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-${
                            translatedRenewalItems.find(
                              (it) => it.value === time,
                            ).text
                          }`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          :label="
                            translatedRenewalItems.find(
                              (it) => it.value === time,
                            ).text
                          "
                        />
                      </div>
                    </v-chip>
                  </div>
                  <v-divider class="my-4" />
                  <v-expand-transition>
                    <div v-if="massUpdatePriceData?.total_count">
                      <v-row class="ma-0" align="center">
                        <v-col cols="12" class="text-h6">
                          {{ $t("listCardHeader.total_count") }}:
                          <span v-if="!priceloading" class="font-weight-bold">{{
                            use_lang(massUpdatePriceData?.total_count)
                          }}</span>
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          <v-btn
                            text
                            color="primary"
                            @click="showDetails = !showDetails"
                            class="mr-2"
                          >
                            <v-icon>{{
                              showDetails
                                ? "mdi-chevron-double-up"
                                : "mdi-chevron-double-down"
                            }}</v-icon>
                            {{ $t("listCardHeader.details") }}
                          </v-btn>
                        </v-col>
                        <v-col v-if="showDetails" cols="12" class="pa-2">
                          <v-sheet class="slider-wrapper" elevation="6">
                            <v-slide-group
                              v-model="model"
                              class="mt-2"
                              show-arrows
                              center-active
                            >
                              <v-slide-item
                                v-for="(item, index) in qrTypeCounts"
                                :key="index"
                              >
                                <v-card
                                  elevation="4"
                                  rounded="lim"
                                  class="pa-2 text-center ma-1"
                                  style="
                                    position: relative;
                                    border-radius: 10px;
                                    max-width: 200px;
                                    margin: 0 auto;
                                  "
                                >
                                  <v-badge
                                    :content="item.value"
                                    color="warning"
                                    manchot-x="10"
                                    offset-y="10"
                                  >

                                    <img 
                                      v-if="displayMap[item.key] && displayMap[item.key].type === 'image'" 
                                      :src="displayMap[item.key].src" 
                                      style="width: 26px; height: 26px; object-fit: contain;" 
                                      alt="logo"
                                    />
                                    
                                    <v-icon v-else large color="#ca3102ff">
                                      mdi-{{ getQrTypes(item.key)?.icon || "qrcode" }}
                                    </v-icon>
                                  </v-badge>
                                  <div
                                    class="mt-1 text-subtitle-1 font-weight-medium"
                                  >
                      
                                    {{ getQrTypes(item.key)?.name || item.key }}
                                  </div>
                                </v-card>
                              </v-slide-item>
                            </v-slide-group>
                          </v-sheet>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="text-h6">
                          {{ $t("listCardHeader.total_amount") }}:
                          <span
                            v-if="!priceloading"
                            class="font-weight-bold text-decoration-line-through"
                          >
                            {{
                              persian(
                                (
                                  massUpdatePriceData?.sum_price *
                                  (1 +
                                    massUpdatePriceData?.discountPriceByCount *
                                      0.001)
                                ).toLocaleString(),
                              )
                            }}
                          </span>
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          ﷼
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="text-h6">
                          {{ $t("listCardHeader.discount") }}:
                          <span
                            v-if="!priceloading"
                            class="font-weight-bold"
                            style="color: red"
                          >
                            {{
                              persian(
                                (
                                  massUpdatePriceData?.sum_price *
                                  massUpdatePriceData?.discountPriceByCount *
                                  0.001
                                ).toLocaleString(),
                              )
                            }}
                          </span>
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          ﷼
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="text-h6">
                          {{ $t("listCardHeader.final_amount_with_discount") }}
                          <span v-if="!priceloading" class="font-weight-bold">{{
                            persian(
                              massUpdatePriceData?.sum_price.toLocaleString(),
                            )
                          }}</span>
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          ﷼
                        </v-col>
                      </v-row>
                      <v-alert type="info" dense text class="ma-4">
                        {{ $t("listCardHeader.ten_percent_vat_will_be_added") }}
                      </v-alert>
                      <v-row class="ma-0" justify="center">
                        <v-col cols="auto">
                          <v-btn
                            :loading="paymentloading"
                            color="success"
                            class="font-weight-bold px-8"
                            large
                            @click="handleMassUpdate(time)"
                          >
                            <div class="cons">
                              <v-icon left>mdi-credit-card</v-icon>
                              {{ $t("listCardHeader.pay_and_upgrade") }}
                              <help-info
                                :element-name="`${serviceName}-${componentName}-pay-update`"
                                :help-data="helpData"
                                :service-name="serviceName"
                                class="buttoninfo"
                                :label="$t('listCardHeader.pay_and_upgrade')"
                              />
                            </div>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-expand-transition>
                  <v-expand-transition>
                    <div
                      v-if="!massUpdatePriceData?.total_count && !loading"
                      class="text-center"
                    >
                      <v-icon color="error" left>mdi-currency-usd</v-icon>
                      {{ $t("listCardHeader.no_tariff_for_this_period") }}
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </custom-popup>
        <v-card-title class="grey--text justify-end">
          <div v-if="!showCheck" class="rowinfo">
            <v-btn
              class="btn-send-sms pa-0 px-md-2"
              min-width="36"
              @click="$router.push({ name: 'qr.cat' })"
            >
              <v-icon class="me-md-2">mdi-plus</v-icon>
              <span class="d-none d-md-inline-block">{{
                $t("listCardHeader.add_qr")
              }}</span>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-addQr-btn`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('listCardHeader.add_qr')"
            />
          </div>
          <div
            v-else
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
          >
            <v-checkbox
              v-model="checkAll"
              class="mx-2 my-3"
              hide-details
              :label="$t('listCardHeader.select_all')"
              off-icon="mdi-minus-box"
              @click="changeCheckBox"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-selectAll`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('listCardHeader.filter')"
            />
          </div>
          <v-divider class="ma-2" vertical />
          <v-spacer class="d-md-none" />
          <div v-if="!showCheck" class="rowinfo comp">
            <header-status-filter v-model="statusFilter" :count="count" />
            <help-info
              :element-name="`${serviceName}-${componentName}-statusFilter`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('listCardHeader.filter')"
            />
          </div>
          <div
            v-else
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
          >
            <v-menu v-model="actionMenu" bottom nudge-bottom="5" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on">
                  {{ $t("listCardHeader.actions") }}
                  <v-fade-transition mode="out-in">
                    <v-icon v-if="!actionMenu" key="down" class="ms-2"
                      >mdi-chevron-down</v-icon
                    >
                    <v-icon v-else key="up" class="ms-2">mdi-chevron-up</v-icon>
                  </v-fade-transition>
                </v-btn>
              </template>
              <v-list dense>
                <template v-for="(item, i) in translatedItemsAction">
                  <v-list-item
                    v-if="item.condition"
                    :key="i"
                    color="primary"
                    @click="item.handler()"
                  >
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
            <help-info
              :element-name="`${serviceName}-${componentName}-actionMenu`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('listCardHeader.filter')"
            />
          </div>
          <div
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center comp"
          >
            <header-type-filter
              v-model="typeFilter"
              :count="count"
              :key="$i18n.locale"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-typeFilter`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo cosnt2"
              :label="$t('listCardHeader.type_filter')"
            />
          </div>
          <div v-if="showCheck" class="rowinfo">
            <v-btn
              class="my-auto btn-edit contentinfo const3"
              depressed
              @click="priceDial = true"
            >
              <v-icon left>mdi-timer-refresh-outline</v-icon>
              {{ $t("listCardHeader.group_qr_renewal") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-priceDial`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              :label="$t('listCardHeader.group_qr_renewal')"
            />
          </div>
          <slot name="content" />
          <v-spacer class="d-none d-md-flex" />
          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <v-text-field
                v-model="identifier"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                hide-details
                :label="$t('listCardHeader.start_from')"
                outlined
                @keydown.enter="updateIdentifierFilter(identifier)"
                @click:clear="updateIdentifierFilter(null)"
              >
                <template v-slot:append>
                  <v-progress-circular
                    v-if="loading && identifier && identifier.length >= 3"
                    color="primary"
                    indeterminate
                    size="20"
                    width="3"
                  />
                  <v-btn
                    v-else
                    class="mt-n1"
                    icon
                    small
                    @click="updateIdentifierFilter(identifier)"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-identifier`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('listCardHeader.search')"
              />
            </div>
          </v-card>
          <v-card class="ma-2" flat max-width="250" width="250">
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center comp"
            >
              <header-search-type-filter
                v-model="computedSearch"
                :loading="loading"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedSearch`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('listCardHeader.search')"
              />
            </div>
          </v-card>
          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo comp mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <header-expire-type-filter v-model="computedExpireTypeFilter" />
              <help-info
                :element-name="`${serviceName}-${componentName}-expireTypeFilter`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('listCardHeader.search')"
              />
            </div>
          </v-card>
          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <v-text-field
                v-model="idSearch"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                hide-details
                :label="$t('listCardHeader.id_search')"
                outlined
                @keydown.enter="updateIdSearchFilter(idSearch)"
                @click:clear="updateIdSearchFilter(null)"
              >
                <template v-slot:append>
                  <v-progress-circular
                    v-if="loading && idSearch"
                    color="primary"
                    indeterminate
                    size="20"
                    width="3"
                  />
                  <v-btn
                    v-else
                    class="mt-n1"
                    icon
                    small
                    @click="updateIdSearchFilter(null)"
                  >
                    <v-icon>mdi-identifier</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-idSearch`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo const2"
                :label="$t('listCardHeader.id_search')"
              />
            </div>
          </v-card>
          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <users-picker
                v-model="computedUserFilter"
                class="contentinfo"
                hide-details
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedUserFilter`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo const2"
                :label="$t('listCardHeader.filter_user')"
              />
            </div>
          </v-card>
          <v-card
            :disabled="(showCheck || count <= 0) && !hasError"
            class="ma-2 pa-0 d-flex row rowinfo align-center"
            flat
            max-width="250"
          >
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 align-center comp"
            >
              <v-select
                v-model="computedSortFilter"
                :items="translatedItemsFilter"
                :menu-props="{ offsetY: true }"
                class="contentinfo"
                dense
                hide-details
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedSortFilter`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo const2"
                :label="$t('listCardHeader.sort')"
              />
            </div>
          </v-card>
        </v-card-title>
        <v-card
          v-if="$route.name === 'qr.monitoring'"
          class="ma-2"
          flat
          max-width="500"
          width="500"
        >
        <div class="d-flex flex-row">
        <div
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
          >
            <v-select
              v-model="historyFilter"
              :items="history"
              item-text="text"
              item-value="value"
              :label="'فیلتر تاریخچه'"
              clearable
              dense
              hide-details
              outlined
              class="contentinfo"
            >
              <template v-slot:item="{ item }">
                <v-icon :color="item.color" left>{{ item.icon }}</v-icon>
                {{ item.text }}
              </template>
              <template v-slot:selection="{ item }">
                <v-icon :color="item.color" left small>{{ item.icon }}</v-icon>
                <span class="text-truncate">{{ item.text }}</span>
              </template>
            </v-select>

            <help-info
              :element-name="`${serviceName}-${componentName}-historyFilter`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="'فیلتر تاریخچه'"
            />
          </div>
          <div
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
          >
            <v-combobox
            v-model="TagFilter"
            :items="Tags"
            item-text="text"
            item-value="text"
            :label="'فیلتر تگ'"
            clearable
            dense
            hide-details
            outlined
            class="contentinfo"
          >
            <template v-slot:item="{ item }">
              <v-icon :color="item.color" left>{{ item.icon }}</v-icon>
              {{ item.text }}
            </template>
            <template v-slot:selection="{ item }">
              <v-icon v-if="item.icon" :color="item.color" left small>{{ item.icon }}</v-icon>
              <span class="text-truncate">{{ typeof item === 'string' ? item : item.text }}</span>
            </template>
          </v-combobox>

            <help-info
              :element-name="`${serviceName}-${componentName}-tagFilter`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="'فیلتر تگ'"
            />
          </div>
        </div>
         
        </v-card>
        <v-card-title v-if="$slots.extension" class="pt-0">
          <slot name="extension"></slot>
          <div
            class="d-flex row row mx-0 mt-0 pa-0 px-md-0 align-center justify-end const4"
            :style="
              !hasValidHelpinfo(`${serviceName}-${componentName}-resetStates`)
                ? 'margin-left: 20px !important'
                : 'margin-left: 0px !important'
            "
          >
            <v-btn
              :disabled="!hasFilter && !historyFilter"
              class="ma-0 btn-exit"
              depressed
              @click="clearAllFilters"
            >
              {{ $t("listCardHeader.clear_filters") }}
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-resetStates`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('listCardHeader.clear_filters')"
            />
          </div>
        </v-card-title>

        <v-divider class="mx-3" />
        <custom-popup
          v-model="smsDialog"
          :cons="{ title: $t('listCardHeader.send_sms') }"
          hide-confirm
          max-width="700"
        >
          <v-card class="p-8">
            <div
              v-if="description.desc && description.id"
              class="col-md-12 mx-auto p-3"
              style="
                background-color: rgb(212, 212, 212);
                color: black;
                font-weight: bold;
              "
            >
              <v-icon
                class="float-left"
                @click="
                  description.desc = '';
                  description.id = '';
                "
                >mdi-delete</v-icon
              >
              <p>{{ $t("listCardHeader.selected_pattern") }}</p>
              <p class="mt-1 pt-0" v-html="description.desc"></p>
            </div>
            <patterns-list v-model="description" />
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <v-btn
                :disabled="!description.id"
                :loading="loading"
                class="mt-10 btn-send-sms contentinfo"
                outlined
                @click="sendPattern"
              >
                <v-icon left small>mdi-send</v-icon>
                {{ $t("listCardHeader.send") }}
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-sendPattern`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('listCardHeader.send')"
              />
            </div>
          </v-card>
        </custom-popup>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import PatternsList from "../../robot/patternsList";
import { mapActions, mapGetters, mapState } from "vuex";
import HeaderTypeFilter from "./headerTypeFilter.vue";
import HeaderStatusFilter from "./headerStatusFilter";
import UsersPicker from "../../../components/pickers/usersPicker";
import HeaderExpireTypeFilter from "./headerExpireTypeFilter";
import HeaderSearchTypeFilter from "./headerSearchTypeFilter";

export default {
  name: "listCardHeader",
  components: {
    HelpInfo,
    HelpInfoWrapper,
    HeaderSearchTypeFilter,
    HeaderExpireTypeFilter,
    UsersPicker,
    HeaderStatusFilter,
    HeaderTypeFilter,
    PatternsList,
  },
  props: {
    count: { type: [Number, String], default: 0 },
    value: Boolean,
    showCheck: Boolean,
    qrCard: [Object, Array],
    isLoading: Boolean,
    massUpdatePrice: Function,
    massUpdatePriceData: Object,
    massUpdate: Function,
    qrTypeCounts: Array,
  },
  data() {
    return {
     displayMap: {
        'eitaa': { type: 'image', src: '/media/socialnetwork/icon/eitaa_wb.webp' },
        'bale': { type: 'image', src: '/media/socialnetwork/icon/bale_wb.webp' },
        'robika': { type: 'image', src: '/media/socialnetwork/icon/robika_wb.webp' }
      },
      TagFilter: null,
      historyFilter: null,
      Tags: [
        { 
          text: "همه", 
          value: "all",
          color: "grey", 
          icon: "mdi-sigma" 
        },
        {
          text: "پاسخ نداده",
          value: "no_answer",
          color: "error", 
          icon: "mdi-phone-missed"
        },
        { 
          text: "نیاز نداشته",
          value: "no_need",
          color: "warning", 
          icon: "mdi-minus-circle-outline" 
        },
        { 
          text: "پرسنل",
          value: "staff",
          color: "blue", 
          icon: "mdi-account-circle-outline" 
        },
        // ---------------- مارکت‌پلیس‌ها / پلتفرم‌ها ----------------
        { 
          text: "مارکت‌پلیس (دیجی‌کالا)", 
          value: "digikala",
          color: "red darken-1", 
          icon: "mdi-shopping" 
        },
        { 
          text: "مارکت‌پلیس (باسلام)", 
          value: "basalam",
          color: "amber darken-3", 
          icon: "mdi-storefront" 
        },
        { 
          text: "مارکت‌پلیس (ترب)", 
          value: "torob",
          color: "red darken-3", 
          icon: "mdi-tag-multiple-outline" 
        },
        { 
          text: "مارکت‌پلیس (اسنپ‌شاپ)", 
          value: "snapp_shop",
          color: "purple darken-1", 
          icon: "mdi-basket-outline" 
        },
        { 
          text: "مارکت‌پلیس (سایر)", 
          value: "other_marketplaces",
          color: "teal", 
          icon: "mdi-store" 
        }
      ],
      history: [
        { text: "همه", value: "all", color: "grey", icon: "mdi-sigma" },
        {
          text: "بدون تاریخچه",
          value: "empty",
          color: "#F7DC45",
          icon: "mdi-history-off",
        },
        {
          text: "دارای تاریخچه",
          value: "has",
          color: "#6CF76C",
          icon: "mdi-history",
        },
        {
          text: "زمان یادآوری گذشته",
          value: "passed",
          color: "#8B0700",
          icon: "mdi-bell-alert",
        },
        {
          text: "زمان آخرین یادآوری رسیده",
          value: "now",
          color: "#ca3102ff",
          icon: "mdi-bell-ring",
        },
      ],
      model: null,
      showDetails: false,
      selectedTime: null,
      selectedItemsDetails: [],
      cardloading: false,
      priceloading: false,
      paymentloading: false,
      popupLoading: false,
      serviceName: "Qrland",
      componentName: "list-card-header",
      helpData: [],
      priceDial: false,
      drawer: false,
      actionMenu: false,
      search: "",
      identifier: "",
      idSearch: "",
      checkAll: false,
      smsDialog: false,
      bulkStatus: "",
      description: {},
      itemsFilter: [
        { value: "desc", key: "newest" },
        { value: "asc", key: "oldest" },
        { value: "mostVisited", key: "most_visited" },
        { value: "fewerVisited", key: "least_visited" },
      ],
      itemsAction: [
        {
          value: "pause",
          key: "pause",
          handler: this.pauseAll,
          condition: true,
        },
        {
          value: "bulkDownload",
          key: "bulk_download",
          handler: this.bulkDownload,
          condition: true,
        },
        {
          value: "sendSms",
          key: "send_sms",
          handler: this.sendSms,
          condition: this.$route.name === "qr.monitoring",
        },
      ],
      renewalItems: [
        { value: 30, key: "one_month_renewal" },
        { value: 90, key: "three_month_renewal" },
        { value: 180, key: "six_month_renewal" },
        { value: 365, key: "one_year_renewal" },
      ],
      time: 0,
    };
  },
  mounted() {
    this.identifier = this.identifierFilter;
    this.idSearch = this.idSearchFilter;
  },
  computed: {
    ...mapGetters("ribbon", ["user"]),
    ...mapGetters("localstorage", [
      "statusFilter",
      "typeFilter",
      "sortFilter",
      "searchTypeFilter",
      "hasFilter",
      "identifierFilter",
      "idSearchFilter",
      "userFilter",
      "expireTypeFilter",
      "pageFilter",
    ]),
    ...mapState("localstorage", ["hasError"]),
     computedExpireTypeFilter: {
    get() {
      return this.expireTypeFilter;
    },
    set(val) {
        console.log("Updating Store with:", value);
      this.updateExpireTypeFilter(val);
    },
  },
    translatedRenewalItems() {
      return this.renewalItems.map((item) => ({
        value: item.value,
        text: this.$t(`listCardHeader.${item.key}`),
      }));
    },
    translatedItemsFilter() {
      return this.itemsFilter.map((item) => ({
        value: item.value,
        text: this.$t(`listCardHeader.${item.key}`),
      }));
    },
    translatedItemsAction() {
      return this.itemsAction.map((item) => ({
        value: item.value,
        text: this.$t(`listCardHeader.${item.key}`),
        handler: item.handler,
        condition: item.condition,
      }));
    },
    computedSortFilter: {
      get() {
        return this.sortFilter;
      },
      set(val) {
        this.updateSortFilter(val);
      },
    },
    loading: {
      get() {
        return this.isLoading;
      },
      set(val) {
        this.$emit("emitLoading", val);
      },
    },
    computedPerPage: {
      get() {
        return this.perPageFilter;
      },
      set(val) {
        this.updatePerPageFilter(val);
      },
    },
    computedPage: {
      get() {
        return this.pageFilter;
      },
      set(val) {
        this.updatePageFilter(val);
      },
    },
    computedUserFilter: {
      get() {
        return this.userFilter;
      },
      set(val) {
        this.updateUserFilter(val);
      },
    },
    computedSearch: {
      get() {
        return this.searchTypeFilter;
      },
      set(val) {
        this.updateSearchTypeFilter(val);
      },
    },
  },
  watch: {
    TagFilter(val){
      const emitValue = (val && typeof val === 'object') ? val.text : val;
      this.$emit("tag-change", emitValue);
      },
    historyFilter(val) {
      this.$emit("history-change", val);
    },
    value(val) {
      this.checkAll = val;
    },
    checkAll(val) {
      this.$emit("input", val);
    },
    identifierFilter(val) {
      this.identifier = val;
    },
    idSearchFilter(val) {
      this.idSearch = val;
    },
    qrCard(val) {
      let obj = val
        .map((item) => item.status)
        .reduce((acc, curr) => {
          acc[curr] = (acc[curr] || 0) + 1;
          return acc;
        }, {});
      let status = "";
      let count = Infinity;
      for (const key in obj) {
        if (obj[key] < count) {
          count = obj[key];
          status = key;
        }
      }
      this.bulkStatus =
        Object.keys(obj).length >= 2
          ? status
          : status === "active"
          ? "deactivate"
          : "active";
      this.$nextTick(() => {
        this.itemsAction.find((item) => item.value === "pause").key =
          this.bulkStatus;
      });
    },
    "massUpdatePriceData.close"(val) {
      this.$nextTick(() => {
        this.priceDial = false;
      });
    },
    priceDial(val) {
      if (val) {
        this.popupLoading = true;
        this.$nextTick(() => {
          this.popupLoading = false;
        });
      } else {
        this.priceloading = false;
        this.popupLoading = false;
        this.paymentloading = false;
      }
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions("localstorage", [
      "updateSortFilter",
      "updateSearchTypeFilter",
      "updateIdentifierFilter",
      "updateIdSearchFilter",
      "updateUserFilter",
      "resetStates",
      "updateExpireTypeFilter", 
    ]),
    clearAllFilters() {
    this.historyFilter = null; 
    this.resetStates(); 
  },
    async showCardDetails(time) {
      this.selectedTime = time;
      this.cardloading = true;
      try {
        await this.massUpdatePrice(time);
        this.showDetails = true;
      } catch (error) {
        this.$toast.error(this.$t("listCardHeader.error_loading_card"));
        this.cardloading = false;
      } finally {
        this.cardloading = false;
      }
    },
    changeCheckBox() {
      this.$nextTick(() => {
        this.$emit("check", this.checkAll);
      });
    },
    hasValidHelpinfo(elementName) {
      if (
        (!this.helpData ||
          !Array.isArray(this.helpData) ||
          this.helpData.length === 0) &&
        !this.ribbon_can("guideuser")
      ) {
        return false;
      }
      const itemElement = this.helpData?.find(
        (p) =>
          p.name &&
          typeof p.name === "string" &&
          p.name.trim() === (elementName?.trim() || ""),
      );
      return itemElement || this.ribbon_can("guideuser");
    },
    pauseAll() {
      this.$emit("pause-sel", this.bulkStatus);
    },
    bulkDownload() {
      this.loading = true;
      let qrs = this.qrCard?.map((item) => {
        return {
          img_url: item.img__url,
          image: item.image,
          title: item.title.replace(/\s+/g, "_"),
        };
      });
      const counts = {};
      const result = qrs.map((item) => {
        if (item.title in counts) {
          counts[item.title]++;
          item.title = `${item.title}(${counts[item.title] - 1})`;
        } else {
          counts[item.title] = 1;
        }
        return item;
      });
      let link =
        this.$route.name === "qr.monitoring"
          ? "/admin/download"
          : "/v1/testQr/download-qrs";
      this.$api
        .post(link, { qrs: result })
        .then(({ data }) => {
          if (data) {
            if (data.status) {
              this.$toast.success(data.message);
              let a = document.createElement("a");
              a.setAttribute("href", `${this.$qrUrl}/qr/zip/${data.data}`);
              a.setAttribute("target", "_blank");
              a.download = data.data;
              a.click();
            } else {
              this.$toast.error(data.message);
            }
          }
        })
        .catch(({ response }) => {
          console.log("error in bulk download: ", response);
          this.$toast.error(this.$t("listCardHeader.generic_error"));
        })
        .finally(() => (this.loading = false));
    },
    sendSms() {
      this.smsDialog = true;
    },
    sendPattern() {
      this.loading = true;
      let patternCount = 0;
      try {
        const regex = new RegExp(/data\d+/, "gd");
        patternCount = this.description.content.match(regex).length;
      } catch (e) {}
      this.$api
        .post("/admin/qr/sms", {
          qr_ids: this.qrCard.map((item) => item.id),
          pattern_id: this.description.id,
          length: patternCount,
        })
        .then(({ data }) => {
          this.$toast.success(this.$t("listCardHeader.sms_success"));
          this.smsDialog = false;
        })
        .catch(({ response }) => {
          console.log("error in send qr sms: ", response);
          this.$toast.error(this.$t("listCardHeader.generic_error"));
        })
        .finally(() => (this.loading = false));
    },
    async getPrice(time) {
      this.priceloading = true;
      try {
        this.time = time;
        await this.massUpdatePrice(time);
      } catch (error) {
        this.$toast.error(this.$t("listCardHeader.error_fetching_prices"));
        this.time = 0;
      } finally {
        setTimeout(() => {
          this.priceloading = false;
        }, 500);
      }
    },
    async handleMassUpdate(time) {
      this.paymentloading = true;
      try {
        await this.massUpdate(time);
      } catch (error) {
        this.$toast.error(this.$t("listCardHeader.error_payment"));
      } finally {
        this.paymentloading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-input--checkbox >>> .v-label {
  margin: 0 4px;
}
.comp {
  flex-wrap: nowrap !important;
  display: flex;
  flex-direction: row;
}
.cons {
  display: flex;
  justify-content: center;
  align-items: center;
}
.const2 {
  align-content: center !important;
  align-self: center !important;
}
.const3 {
  padding-left: 16px !important;
  justify-content: center;
  box-sizing: border;
}
.const4 {
  min-width: min-content;
  max-width: fit-content;
  margin-bottom: unset;
}
</style>
